export default "__VITE_ASSET__16d003f3__"